var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":_vm.id}},[_c('div',{staticClass:"toolbar"}),_c('Editor',{class:['outline-class', _vm.showToolbar ? 'editorcontent' : ''],attrs:{"init":_vm.editorInit},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }